export const init = ({
  adminId,
  adminEmail,
  clientId,
  clientName,
  pendoId,
  clientType,
}) => {
  // eslint-disable-next-line no-undef
  pendo.initialize({
    apiKey: pendoId,
    visitor: {
      id: adminId,
      email: adminEmail,
      clienttype: clientType,
    },
    account: {
      id: clientId,
      name: clientName,
      clienttype: clientType,
    },
  });
  setTimeout(() => {
    document.getElementsByTagName('body')[0].classList.add('pendoOn');
  }, 3000);
};

export default init;
